import { render, staticRenderFns } from "./UpcomingLeaveRequestWidget.vue?vue&type=template&id=75aac784&"
import script from "./UpcomingLeaveRequestWidget.vue?vue&type=script&lang=js&"
export * from "./UpcomingLeaveRequestWidget.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingLeaveRequestWidget.vue?vue&type=style&index=0&id=75aac784&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports